export default __webpack_public_path__ + "static/media/ucha-aplicacao.15794a7a.png";